<template>
  <div class="loader-inner line-scale flex-justify-center">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>

<style lang="scss" scoped>
@import '../_variables.scss';
.loader-inner > div {
  background-color: $teal;
}
</style>



// WEBPACK FOOTER //
// Loader.vue?f89c34ea